import { URL_ENDPOINTS } from "./../../constants/index";
import { TokenType } from "./types";
import { axiosInstance as Api } from "../../utils/api-helper";

const URL = URL_ENDPOINTS.BASE_URL + URL_ENDPOINTS.SECURITY;

const SecurityService = {
  authenticate: async (password: string): Promise<TokenType> => {
    const body = `username=token_temporal&password=${encodeURIComponent(
      password,
    )}&grant_type=password&scope=PEPPER_ONE`;
    return Api.post(URL, body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Basic ${import.meta.env.VITE_CLIENT_SECRET}`,
      },
    });
  },
};

export default SecurityService;
